import { Box, Collapse, TableCell } from '@mui/material';

import SymbolsPreview from '@/components/SymbolsPreview';
import { CommoditiesTableRowType } from '@/pages/Markets/MarketsComponents/types';
import { SelectedSymbol } from '@/types/symbols';

const CollapsedRow = ({
  open,
  lastSymbol,
  diffSymbol,
  row
}: {
  open: boolean;
  lastSymbol: SelectedSymbol;
  diffSymbol: SelectedSymbol;
  row: CommoditiesTableRowType;
}) => {
  return (
    <TableCell
      className='collapsed-table-row'
      colSpan={7}
      sx={theme => ({
        pb: 0,
        pt: 0,
        borderLeft: open ? `2px solid ${theme.palette.primary.main}` : 'none'
      })}
    >
      <Collapse
        unmountOnExit
        in={open}
        timeout='auto'
      >
        <Box sx={{ ml: 3.5 }}>
          <SymbolsPreview
            items={[
              {
                symbol: lastSymbol,
                label: 'Last',
                metadata: row.metadata,
                periodAbs: row.periodAbs
              },
              {
                symbol: diffSymbol,
                label: 'Diff',
                metadata: row.diffMetadata,
                periodAbs: row.diffPeriodAbs
              }
            ]}
          />
        </Box>
      </Collapse>
    </TableCell>
  );
};

export default CollapsedRow;
